import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import {useLocation } from 'react-router-dom';
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import AccountCircleRoundedIcon from "@material-ui/icons/AccountCircleRounded";
import CloseIcon from "@material-ui/icons/Close";
import { StoreContext } from "../../../../Store/Provider";
import "./header.css";
import MenuBars from "../../../SVG/MenuBars";
import SearchIcon from "../../../SVG/SearchIcon";
import { routeConstant } from "../../../../Route/utils/routeConstant";
import { HOST_URL, ProjectName } from "../../../../Config";
import { getUserData, localStoragekey } from "../../../Common/Utility/Utils";
import axios from "axios";
import instance from "../../../../order_managment/common/api/interceptor";
import { NotificationManager } from "react-notifications";
import { IsShowOrder } from "../../../../utils";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

function Header(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const context = useContext(StoreContext);
  const [search, setSearch] = useState("");
  const [userdata, setUserdata] = useState("");
  const [userSearch, setUserSearch] = useState("");
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    setSearch(props?.shipmentNo);

    if (location.pathname === routeConstant.ShipmentsListing) {
      setSearch("");
    }

    setUserdata(JSON.parse(localStorage.getItem(localStoragekey)));
  }, [location.pathname]);

  useEffect(() => {
    if (context?.omsUserData) {
      const arr = context.omsUserData?.UserRoles?.split(",") ?? [];
      setRolesList(arr ?? []);
    }

    setUserRole(context?.omsUserData?.DefaultRole ?? "");
  }, [context.omsUserData]);

  // console.log(userdata)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const logOut = () => {
    handleClose();
    context.setIsUserLogin(false);
    localStorage.removeItem("sfl_user_data");
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    const handleInvalidToken = (e) => {
      console.log(e);
      if (e.key === "sfl_user_data" && e.oldValue && !e.newValue) {
        logOut();
      }
    };
    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, [logOut]);

  const onClickenter = (event) => {
    if (event.key === "Enter") {
      context.setSearchAdmin(userSearch);
    }
  };

  const updatePassword = () => {
    handleClose();
    navigate(routeConstant.UpdatePassword);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeRole = (role) => {
    instance
      .post(`api/v1/User/switchRole?role=${role}`)
      .then((res) => {
        if (res.Is_Success) {
          NotificationManager.success(res.Message);
          window.location.reload();
        }
      })
      .catch((err) => {
        NotificationManager.error("Can't switch the role");
      });
  };
  const searchIcon = () => {
    // context.setShipmentNo(search);
    context.setAdvSearchFilter({
      value: "",
      tranportMode: "",
      etd: "",
      eta: "",
      ShipmentData: search,
    });
    navigate(routeConstant.AdvSearchResults);
  };

  const startTour = () => {
    context.SetRun(true);
  };

  function downloadBase64File(contentBase64) {
    const linkSource = contentBase64;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = "statement_of_account";
    downloadLink.click();
  }

  const exportToExcel = async () => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const headers = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    const URl = `${HOST_URL}api/v1/AccountStatement/ExportToExcel`;
    const body = {
      SearchText: context?.searchText ?? "",
    };
    axios
      .post(URl, body, {
        headers: headers,
      })
      .then((res) => {
        const Base_64 =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, " +
          res.data;
        console.log(Base_64);
        downloadBase64File(Base_64);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <header className="container-fluid">
      <div className="menuItem_logo">
        <MenuBars
          classMenu={"menuBarIcon"}
          onClick={context.handleMenubar}
          colorCode={"rgba(var(--text-heading-dark))"}
        />
        <a href="https://insights.softfreightlogic.com" target="_blank">
          <img
            className="TourLogo"
            src={`/${ProjectName}/Assets/Images/SFLlogo.png`}
            alt="Company Logo"
          />
        </a>
      </div>
      <div className="searchBar_User">
        <div className="headersearch">
          {location.pathname === routeConstant.ShipmentsListing ||
          location.pathname === routeConstant.Statement ||
          location.pathname === routeConstant.SearchResults ? (
            <>
              <input
                value={search}
                type="text"
                className="form-control TourseventhStep"
                id="headersearch"
                onChange={(event) => {
                  setSearch(event.target.value);
                  context.setShipmentNo("");
                }}
                placeholder={
                  location.pathname === routeConstant.Statement
                    ? "search here for your statement"
                    : " search here for your shipment"
                }
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    if (location.pathname === routeConstant.Statement) {
                      context.setsearchText(event.target.value);
                    } else {
                      context.setAdvSearchFilter({
                        value: "",
                        tranportMode: "",
                        etd: "",
                        eta: "",
                        ShipmentData: search,
                      });
                      navigate(routeConstant.AdvSearchResults);
                    }
                  }
                }}
              />
              <SearchIcon
                onClick={searchIcon}
                colorCode={"rgba(var(--text-heading-dark))"}
                iconClass={"searchIcon"}
              />
              {search && (
                <CloseIcon
                  className="searchClearIcon"
                  onClick={() => {
                    setSearch("");
                    if (location.pathname === routeConstant.Statement) {
                      context.setsearchText("");
                      navigate(routeConstant.Statement);
                    } else {
                      navigate(routeConstant.ShipmentsListing);
                    }
                  }}
                />
              )}
            </>
          ) : null}

          <div className="headersearch">
            {location.pathname === routeConstant.Users ? (
              <>
                <input
                  value={userSearch}
                  type="text"
                  className="form-control"
                  id="headersearch"
                  onChange={(event) => {
                    setUserSearch(event.target.value);
                    context.setSearchAdmin(event.target.value);
                  }}
                  placeholder="Search User"
                  onKeyPress={(event) => {
                    onClickenter(event);
                  }}
                />
                <SearchIcon
                  onClick={searchIcon}
                  colorCode={"rgba(var(--text-heading-dark))"}
                  iconClass={"searchIcon"}
                />
                {userSearch && (
                  <CloseIcon
                    className="searchClearIcon"
                    onClick={() => {
                      setUserSearch("");
                      context.setSearchAdmin("");

                      navigate(routeConstant.Users);
                    }}
                  />
                )}
              </>
            ) : null}
          </div>
        </div>
        <div>
          {location.pathname === routeConstant.Statement ? (
            <button
              className="ExportToExcelButton"
              onClick={() => exportToExcel()}
            >
              Export to excel
            </button>
          ) : null}
        </div>
        {context.isUserLogin && IsShowOrder() ? (
          <div>
            <select
              value={userRole}
              onChange={(e) => {
                handleChangeRole(e.target.value);
                setUserRole(e.target.value);
              }}
            >
              {
                rolesList.map((item) => {
                  return (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  );
                })

                // <option value={"Supplier"}>Supplier</option>
                // <option value={"Agent"}>Agent</option>
              }
            </select>
          </div>
        ) : null}
        <div className="usernotify">
          {context.isUserLogin ? (
            <p className="userName">{userdata?.userFullName ?? ""}</p>
          ) : null}
          <div className="loginicon">
            {context.isUserLogin && (
              <AccountCircleRoundedIcon
                className="logoutIcon"
                onClick={handleClick}
              />
            )}
            <StyledMenu
              id="mailMenu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {context.isUserLogin ? (
                <p className="userEmail">{userdata?.EMail ?? ""}</p>
              ) : null}
              <MenuItem
                onClick={() => {
                  navigate(routeConstant.ArchaiveShipments);
                }}
              >
                View Archive Shipments
              </MenuItem>
              <MenuItem onClick={startTour}>Start Product Tour</MenuItem>
              <MenuItem onClick={updatePassword}>Change Password</MenuItem>
              <MenuItem onClick={logOut}>Log Out</MenuItem>
            </StyledMenu>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
